import { Parallax } from './Parallax';
import isMobile from '../utils/isMobile';

export default function initParallax() {
  if (isMobile()) return;

  new Parallax();
}
